import { IconButton, LabeledInput } from 'components/Blocks';

import { IdCardIcon, RefreshIcon } from 'components/Icons';

import { actions } from 'entities';

import { UserScreenProps } from './types';

type SampleIdsProps = Pick<UserScreenProps, 'refreshUsers' | 'user'>;

function UserSampleId({ user, refreshUsers }: SampleIdsProps): JSX.Element | null {
  const syncId = actions.users.syncSampleId.use({
    onSuccess: ({ sampleId }) =>
      refreshUsers({ mutatedUser: { ...user, sampleId }, isUpdate: true }),
  });

  if (!user.createdAt) return null;

  return (
    <div className="relative w-full">
      <LabeledInput
        value={user?.sampleId || 'N/A'}
        label={'Sample ID'}
        name="sampleId"
        loading={syncId.loading}
        labelIcon={IdCardIcon}
        disabled
      />

      <IconButton
        className="absolute bottom-1 right-2"
        tooltipContent="Sync"
        onClick={() => syncId.execute({ id: user.id })}
        disabled={syncId.loading}
      >
        <RefreshIcon />
      </IconButton>
    </div>
  );
}

export default UserSampleId;
